import { createAction } from "@reduxjs/toolkit";
const actionTypes = {
	login : createAction("login"),
}
export default actionTypes;
